import { Block, PrensaEngine } from '@xprog/prensa'
import { SelectProps } from 'components/Select/Select.types'
import React from 'react'

const SelectStyled = PrensaEngine.styled('select', {})
const SelectOption = PrensaEngine.styled('option', {})
const Label = PrensaEngine.styled('label', {})

const Select: React.FC<SelectProps> = ({ css, disabled, id, label, onChange, options, value }) => {
  return (
    <Block
      css={{
        align: ['column', 'left', 'top'],
        ...css?.container
      }}
    >
      {label && 
        <Label
          htmlFor={id}
          css={{
            fontFamily: '$primary',
            fontSize: '16px',
            fontWeight: '500',
            ml: '$3',
            mb: '$1',
            ...css?.label
          }}
        >
          {label}
        </Label>
      }
      <SelectStyled
        disabled={disabled}
        css={{
          backgroundImage: 'url(assets/opopular/icons/IcAbrirPreto.svg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'calc(100% - 12px)',
          backgroundSize: '13px',
          borderColor: '#BFBFBF',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: '$unset',
          color: '#4D4D4D',
          fontFamily: '$primary',
          fontSize: '16px',
          px: '$3',
          height: '40px',
          width: '100%',
          '&:hover': {
            cursor: 'pointer'
          },
          '&:after': {
            display: 'none'
          },
          'appearance': 'none',
          'mozAppearance': 'none',
          'webkitAppearance': 'none',
          ...css?.select
        }}
        id={id}
        onChange={onChange}
        value={value}
      >
        {options.map((i) => 
          <SelectOption
            key={i.id}
            data-selected={i.selected}
            css={css?.selectOption}
          >
            {i.title}
          </SelectOption>
        )}
      </SelectStyled>
    </Block>
  )
}

export default Select